import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-key",
  "use": "icon-key-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-key\"><path d=\"M443.25546667 486.74133333c-29.35466667-47.104-41.09653333-99.9424-41.09653334-158.72A291.0208 291.0208 0 0 1 695.97866667 34.13333333 291.0208 291.0208 0 0 1 989.86666667 328.02133333a291.0208 291.0208 0 0 1-293.888 293.81973334c-64.64853333 0-117.48693333-17.6128-170.3936-52.90666667l-135.168 135.168 64.64853333 64.7168-82.3296 82.26133333-64.64853333-64.64853333-41.09653334 41.1648 64.64853334 64.64853333-82.3296 82.26133334L102.4 827.5968l340.85546667-340.92373333z m252.7232-335.0528c-99.87413333 0-176.26453333 76.45866667-176.26453334 176.3328s76.3904 176.26453333 176.26453334 176.26453334c99.9424 0 176.3328-76.3904 176.3328-176.26453334 0-99.9424-82.26133333-176.3328-176.3328-176.3328z\" fill=\"#262626\" p-id=\"7137\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/key.svg
// module id = 3yDL
// module chunks = 10